export const API_ENDPOINTS = {
    CONSUMET_URL: "https://consumet-api-xi.vercel.app/",
    BERGA_API_URL: "https://berga-api.vercel.app/",
    GET_TRENDING_MOVIES: "get-trending-movies/",
    GET_TRENDING_SHOWS: "get-trending-tv-shows/",
    GET_LATEST_MOVIES: "get-latest-movies/",
    GET_LATEST_SHOWS: "get-latest-tv-shows/"
}